import { editorPicks } from "@/mocks/comics";

export default function EditorPicks() {
  return (
    <section className="w-full bg-accent-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1180px] px-4 md:px-6">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-200 px-3 py-1 text-xs text-accent-900">
              <i className="ri-award-line text-sm" aria-hidden="true"></i>
              本周编辑精选
            </span>
            <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">三本值得先读的选择</h2>
          </div>
          <p className="max-w-[420px] text-sm leading-relaxed text-foreground-600">
            不是按热度排的榜单，而是编辑部本周翻完后觉得「值得先看」的三部，各自代表一种阅读节奏。
          </p>
        </div>

        <div className="mt-7 grid grid-cols-1 gap-4 md:grid-cols-3">
          {editorPicks.map((pick) => (
            <article
              key={pick.no}
              className="flex flex-col rounded-lg border border-accent-200 bg-background-50 p-5"
            >
              <div className="flex items-baseline justify-between">
                <span className="font-heading text-3xl text-accent-400">{pick.no}</span>
                <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] text-secondary-900">
                  {pick.genre}
                </span>
              </div>
              <h3 className="mt-3 font-heading text-lg text-foreground-950">{pick.title}</h3>
              <p className="mt-1 inline-flex items-center gap-1.5 text-xs text-foreground-500">
                <i className="ri-timer-line" aria-hidden="true"></i>
                {pick.readTime}
              </p>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">{pick.reason}</p>
              <p className="mt-3 text-xs text-accent-800">{pick.suitable}</p>
              <a
                href="#latest"
                className="mt-4 inline-flex w-fit items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
              >
                加入阅读
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}